import * as React from "react";
import { useRef } from 'react'
import * as ReactDOM from "react-dom";
import { useFormikContext, Field, Form, Formik, FormikProps, FormikTouched } from 'formik';
import { WorkStatus, LoanPurpose, HomeStatus, CivilStatus } from "./applicationEnums"
import { useSpring, animated } from 'react-spring';
import MaskedInput from 'react-text-mask'
import CoApp from "./CoApp";
import { trackPage } from "../util/gtm-pv"
import NumberFormat from 'react-number-format';
import { FormValues } from "./applicationform";

const interest = 0.0695 / 12;

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

function executeScroll() {
    React.useEffect(() => {
        window.scrollTo(0, 110);
        trackPage(window.location.pathname);
    }, [])
};


function validateSSN(value) {
    let error;
    if (!value) {
        error = 'Personnummer krävs';
    } else if (! /^(19|20)?(\d{6}(-|\s)\d{4})$/i.test(value)) {
        error = 'Ogiltigt personnummer';
    }
    return error;
}

const StepTwo: React.FunctionComponent = () => {
    const { values, setFieldValue, handleChange, handleBlur, errors, touched, isValid } = useFormikContext<any>();
    const spring = useSpring({ opacity: 1, from: { opacity: 0 } })
    var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + "#ansokan";
    window.history.pushState({ path: stepQuery }, '', stepQuery)
    executeScroll()
    return (
        <animated.div style={spring} className="stepTwo" >
            <div className="col-12 row step-container-desktop d-none d-lg-flex">
                <div className="d-flex mx-auto ">
                    <div className="circle colored-circle">
                        1
                        <div className="circle-text">Låninformation</div>
                    </div>
                    <div className="line" />
                    <div className="circle colored-circle">
                        2
                        <div className="circle-text">Personlig information</div>

                    </div>
                    <div className="line" />
                    <div className="circle">
                        3
                        <div className="circle-text">Lånerbjudanden</div>
                    </div>
                </div>
            </div>
            <div className="step-container-mobile d-lg-none">
                <div className="d-flex mx-auto stepsMobile">
                    Låninformation {'>'} <div className="current-step">Personlig information {'>'} </div> Lånerbjudanden
                    </div>

            </div>


            <div className={"input-group valid row" }>
                <div className="headline">Om dine lån</div>
                <div className="form-group col-lg-4">
                    <label htmlFor="amount" className="control-label col-lg-12">Lånebelopp</label>
                    <Field name="amount" id="amount" className={errors.amount && touched.amount ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " min="5000" max="600000"/>
                    <label className="input-type">kr</label>
                    <div className="error-container">
                        {errors.amount && touched.amount && (<div className="text-danger">{errors.amount}</div>)}</div>
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="repaymentTime" className="control-label col-lg-12">Lånetid</label>
                    <Field name="repaymentTime" id="repaymentTime" type="number" className={errors.repaymentTime && touched.repaymentTime ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " min="1" max="20" />
                    <label className="input-type">år</label>
                    <div className="error-container">
                        {errors.repaymentTime && touched.repaymentTime && (<div className="text-danger">{errors.repaymentTime}</div>)}</div>
                </div>

                <div className="form-group col-lg-4">
                    <label className="control-label col-lg-12">Cirka månadskostnad</label>
                    <input className="text-input" value={Math.round(values.amount * interest / (1 - Math.pow(1 + interest, -(values.repaymentTime * 12))))} />
                    <label className="input-type">kr</label>
                  
                </div>
            </div>

            <div className={!errors.email && touched.email && !errors.civilStatus && touched.civilStatus && !errors.phoneNumber && touched.phoneNumber && !errors.idNumber && touched.idNumber ? "input-group valid row" : "input-group row"}>
                <div className="headline">Personlig information</div>
                <div className="form-group row col-lg-6">
                    <label htmlFor="email" className="control-label col-lg-12">Email</label>
                    {!errors.email && values.email != "" && <span className="input-valid"><img src="/images/check.svg" /></span>}
                    <div className="input-icon"><img src="/images/mail.svg" /></div><Field name="email" id="email" className={errors.email && touched.email ? "text-input email-input error" : "text-input email-input"} onChange={handleChange} placeholder=" " />
                    <div className="error-container">
                        {errors.email && touched.email && (<div className="text-danger">{errors.email}</div>)}</div>
                </div>
                <div className="form-group col-lg-6">
                    <label htmlFor="civilStatus" className="col-lg-12 control-label">Civilstånd</label>
                    <select
                        name="civilStatus"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={errors.civilStatus && touched.civilStatus ? "select-input error" : "select-input"}
                        defaultValue=""
                    >
                        <option value="" disabled hidden>- Välj -</option>
                        <option value={CivilStatus[CivilStatus.married]}>Gift</option>
                        <option value={CivilStatus[CivilStatus.single]}>Singel</option>
                        <option value={CivilStatus[CivilStatus.partner]}>Sambo</option>
                    </select>
                    <div className="error-container">
                        {errors.civilStatus && touched.civilStatus && (<div className="text-danger">{errors.civilStatus}</div>)}</div>
                </div>
                <div className="form-group row col-lg-6">
                    <label htmlFor="phoneNumber" className="control-label col-lg-12">Telefonnummer</label>
                    {!errors.phoneNumber && values.phoneNumber != "" && <span className="input-valid"><img src="/images/check.svg" /></span>}
                    <div className="input-icon"><img src="/images/phone.svg" /></div><Field name="phoneNumber" id="phoneNumber" className={errors.phoneNumber && touched.phoneNumber ? "text-input email-input error" : "text-input email-input"} onChange={handleChange} placeholder="07 XXXX XXXX" />
                    <div className="error-container">
                        {errors.phoneNumber && touched.phoneNumber && (<div className="text-danger">{errors.phoneNumber}</div>)}</div>
                </div>
                <div className="form-group col-lg-6">
                    <label htmlFor="idNumber" className="control-label col-lg-12">CPR</label>
                    {!errors.idNumber && touched.idNumber && <span className="input-valid"><img src="/images/check.svg" /></span>}
                    <MaskedInput
                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        className={errors.idNumber && touched.idNumber ? "text-input error" : "text-input"}
                        placeholder="ÅÅÅÅMMDD-XXXX"
                        validate={validateSSN}
                        type="text"
                        onBlur={handleBlur}
                        id="idNumber"
                        name="idNumber"
                        value={values.idNumber}
                        onChange={handleChange}
                    />
                    <div className="error-container">
                        {errors.idNumber && touched.idNumber && (<div className="text-danger">{errors.idNumber}</div>)}</div>
                </div>
            </div>

            <div className={!errors.workStatus && touched.workStatus && !errors.income && touched.income && !errors.workStatusSince && touched.workStatusSince && !errors.livingCost && touched.livingCost ? "input-group valid row" : "input-group row"}>
                <div className="headline">Finans information</div>
                <div className="form-group col-lg-6">
                    <label htmlFor="workStatus" className="control-label col-lg-12">Anställningsform</label>
                    <select
                        name="workStatus"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={errors.workStatus && touched.workStatus ? "select-input error" : "select-input"}
                        defaultValue=""
                    >
                        <option value="" disabled hidden>- Välj -</option>
                        <option value={WorkStatus[WorkStatus.employed]}>Fast anställd</option>
                        <option value={WorkStatus[WorkStatus.selfemployed]}>Egenföretagare</option>
                        <option value={WorkStatus[WorkStatus.temporaryEmployment]}>Tidsbegränsad anställning</option>
                        <option value={WorkStatus[WorkStatus.hourlyEmployment]}>Timanställd</option>
                        <option value={WorkStatus[WorkStatus.retired]}>Pensionerad</option>
                        <option value={WorkStatus[WorkStatus.earlyRetirement]}>Förtidspensionerad</option>
                    </select>
                    <div className="error-container">
                        {errors.workStatus && touched.workStatus && (<div className="text-danger">{errors.workStatus}</div>)}</div>
                </div>
                <div className="form-group col-lg-6">
                    <label htmlFor="income" className="col-lg-12 control-label">Månadsinkomst före skatt.</label>
                    {!errors.income && touched.income && <span className="input-valid"><img src="/images/check.svg" /></span>}
                    <NumberFormat name="income" id="income" max="200000" min="10000" onBlur={handleBlur} className={errors.income && touched.income ? "text-input error" : "text-input"} onChange={handleChange} placeholder="Ex. 40 000" thousandSeparator=" " />
                    {(errors.income || !touched.income) && <label className="input-type">kr</label>}
                    <div className="error-container">
                        {errors.income && touched.income && (<div className="text-danger">{errors.income}</div>)}</div>
                </div>
                {values.workStatus != "retired" && values.workStatus != "earlyRetirement" && values.workStatus != null &&
                    <div className="form-group col-lg-6">
                        <label htmlFor="employer" className="col-lg-12 control-label">Skriva namn på arbetsgivare </label>
                        {!errors.employer && touched.employer && <span className="input-valid"><img src="/images/check.svg" /></span>}
                        <input name="employer" id="employer" onBlur={handleBlur} className={errors.employer && touched.employer ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                        <div className="error-container">
                            {errors.employer && touched.employer && (<div className="text-danger">{errors.employer}</div>)}</div>
                    </div>
                }
                {values.workStatus != "retired" && values.workStatus != "earlyRetirement" && values.workStatus != null &&
                    <div className="form-group col-lg-6">
                        <label htmlFor="employerPhone" className="col-lg-12 control-label">Arbetsgivarens telefonnummer</label>
                        {!errors.employerPhone && touched.employerPhone && <span className="input-valid"><img src="/images/check.svg" /></span>}
                        <input name="employerPhone" id="employerPhone" onBlur={handleBlur} className={errors.employerPhone && touched.employerPhone ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                        <div className="error-container">
                            {errors.employerPhone && touched.employerPhone && (<div className="text-danger">{errors.employerPhone}</div>)}</div>
                    </div>
                }
                <div className="form-group col-lg-6">
                    <label htmlFor="workStatusSince" className="col-lg-12 control-label">Anställd sedan</label>
                    {!errors.workStatusSince && touched.workStatusSince && <span className="input-valid "><img src="/images/check.svg" /></span>}
                    <input type="date" onBlur={handleBlur} name="workStatusSince" id="workStatusSince" className={errors.workStatusSince && touched.workStatusSince ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                    <div className="error-container">
                        {errors.workStatusSince && touched.workStatusSince && (<div className="text-danger">{errors.workStatusSince}</div>)}</div>
                </div>
                <div className="form-group col-lg-6">
                    <label htmlFor="livingCost" className="col-lg-12 control-label">Driftkostnad/månad</label>
                    {!errors.livingCost && touched.livingCost && <span className="input-valid"><img src="/images/check.svg" /></span>}
                    <NumberFormat name="livingCost" max="20000" min="0" id="livingCost" onBlur={handleBlur} className={errors.livingCost && touched.livingCost ? "text-input error" : "text-input"} onChange={handleChange} placeholder="Ex. 4000" thousandSeparator=" " />
                    {(errors.livingCost || !touched.livingCost) && <label className="input-type">kr</label>}
                    <div className="error-container">
                        {errors.livingCost && touched.livingCost && (<div className="text-danger">{errors.livingCost}</div>)}</div>
                </div>
            </div>



            <div className={!errors.children && touched.children && !errors.homeStatus && touched.homeStatus && !errors.loanPurpose && touched.loanPurpose ? "input-group valid row" : "input-group row"}>
                <div className="headline">Hus information</div>
                <div className="form-group col-lg-6">
                    <label htmlFor="children" className="col-lg-12 control-label">Antal barn under 18</label>
                    <select
                        name="children"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={errors.children && touched.children ? "select-input error" : "select-input"}
                        defaultValue=""
                    >
                        <option value="" disabled hidden>- Välj -</option>
                        <option value={0}>0</option>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                        <option value={5}>5</option>
                        <option value={6}>6</option>
                        <option value={7}>7</option>
                        <option value={8}>8</option>
                        <option value={9}>9</option>
                        <option value={10}>10</option>
                    </select>
                    <div className="error-container">
                        {errors.children && touched.children && (<div className="text-danger">{errors.children}</div>)}</div>
                </div>




                <div className="form-group col-lg-6">
                    <label htmlFor="homeStatus" className="col-lg-12 control-label">Boendeform</label>
                    <select
                        name="homeStatus"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={errors.homeStatus && touched.homeStatus ? "select-input error" : "select-input"}
                        defaultValue=""
                    >
                        <option value="" disabled hidden>- Välj -</option>
                        <option value={HomeStatus[HomeStatus.rented]}>Hyresrätt</option>
                        <option value={HomeStatus[HomeStatus.house]}>Hus</option>
                        <option value={HomeStatus[HomeStatus.apartment]}>Lägenhet</option>
                        <option value={HomeStatus[HomeStatus.roommate]}>Rumskamrat</option>
                        <option value={HomeStatus[HomeStatus.parents]}>Föräldrar</option>
                    </select>
                    <div className="error-container">
                        {errors.homeStatus && touched.homeStatus && (<div className="text-danger">{errors.homeStatus}</div>)}</div>
                </div>
                {!values.oldLoanExist &&
                    <div className="form-group col-lg-6">
                        <label htmlFor="loanPurpose" className="col-lg-12 control-label">Lånesyfte</label>
                        <select
                            name="loanPurpose"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={errors.loanPurpose && touched.loanPurpose ? "select-input error" : "select-input"}
                            defaultValue=""
                        >
                            <option value="" disabled hidden>- Välj -</option>
                            <option value={LoanPurpose[LoanPurpose.refinance]}>Återfinansiering</option>
                            <option value={LoanPurpose[LoanPurpose.renovation]}>Renovering</option>
                            <option value={LoanPurpose[LoanPurpose.buyFurniture]}>Köpa möbler</option>
                            <option value={LoanPurpose[LoanPurpose.vehicle]}>Fordon</option>
                            <option value={LoanPurpose[LoanPurpose.buyHouse]}>Bostadsköp</option>
                            <option value={LoanPurpose[LoanPurpose.vacation]}>Semester</option>
                            <option value={LoanPurpose[LoanPurpose.investment]}>Investering</option>
                            <option value={LoanPurpose[LoanPurpose.startBusiness]}>Starta företag</option>
                            <option value={LoanPurpose[LoanPurpose.propertySettlement]}>Fastighetsreglering</option>
                            <option value={LoanPurpose[LoanPurpose.estateInventory]}>Bouppteckning</option>
                            <option value={LoanPurpose[LoanPurpose.other]}>Other</option>
                        </select>
                        <div className="error-container">
                            {errors.loanPurpose && touched.loanPurpose && (<div className="text-danger">{errors.loanPurpose}</div>)}</div>
                    </div>
                }
            </div>
            <div className="input-group row">
                <div className="headline">Medsökande</div>
                <div className="partner-info col-lg-9">
                    <strong> ! </strong>Att lägga till en medsökande ökar dina chanser att få godkänt lånet
            </div>
                <label className="col-lg-12" style={{ color:"#2E384D"}}>Ønsker du at tilføje ansøger</label>
                <div className="col-lg-12">
                    <button className={values.partnerExist ? "coAppButton clicked" : "coAppButton"} type="button" onClick={() => setFieldValue("partnerExist", true)}>Ja</button>
                    <button className={values.partnerExist == false ? "coAppButton clicked" : "coAppButton"} type="button" onClick={() => setFieldValue("partnerExist", false)}>Nej</button>
                </div>
                {values.partnerExist && <CoApp />}
            </div>


        </animated.div>
    )
}

export default StepTwo;